'use strict';
  Object.defineProperty(exports, "__esModule", {
    value: true
  });
  exports.default = void 0;
  
  var _Eye = _interopRequireDefault(require('./lib/icons/Eye'));
  
  function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }
  
  var _default = _Eye;
  exports.default = _default;
  module.exports = _default;